export const InspectionOptionsFRA = [
  {
    id: "opt-1",
    perTime: 2,
    timeFrame: "Week",
    minDays: 1,
    name: "Class 4 and 5 tracks",
    info:
      "For Class 4 and 5 tracks : An inspection can occur on any day of the week. Two inspections must be performed within the same week, with 1 full day between inspections",
  },
  {
    id: "opt-2",
    perTime: 1,
    timeFrame: "Week",
    minDays: 3,
    name: "Freight less then 10 million gross tons",
    info:
      "No Passengers, Freight with less than 10 million gross tons of traffic during preceding year :Must be inspected at least once per week with 3 calendar days between inspections.",
  },
  {
    id: "opt-3",
    perTime: 2,
    timeFrame: "Week",
    minDays: 1,
    name: "Main Track & Sidings Tracks",
    info:
      "For Main Track & Sidings (Other than Class 4 and 5) tracks: Passenger and/or Freight with more than 10 MGT. Two inspections per week with one day interval between inspections",
  },
  {
    id: "opt-4",
    perTime: 1,
    timeFrame: "Month",
    minDays: 20,
    name: "Other than  Main Track & Sidings Tracks",
    info:
      "Other than  Main Track & Sidings (Other than Class 4 and 5) tracks:   Inspection required once in each calendar month with 20 day interval in between inspections ",
  },
];



// WEBPACK FOOTER //
// ./src/templates/FRAInspectionOptions.js